<template>
    <div class="btn" v-on:click="submit()" >
      <img class="img-icon" :src="'/assets/img/' + img + '.jpg'" />
      <div class="bluebg"></div>
      <h1 class="img-text">{{name}}</h1>
    </div>
</template>

<script>


import { EventBus } from "@/event-bus.js";

export default {
     name: 'SubmitButton',
    props: {
      img: String,
      name: String,
      event_name: String,
      button_style: Boolean,
      btnAnimation: Boolean,
    },
    data() {
      return {
        debug: false,
        details: false,
        style_class: '',
      }
    },
    created() {
      if(this.style != "") {
        this.style_class = this.style;
      }
     }, 

     methods: {
      submit: function() {
          EventBus.$emit(""+this.event_name);
      },
      log: function (obj) {
        if(this.debug) {
          console.log(obj)
        }
      }
    }
}
</script>

<style scoped>
  .btn{
    border-radius: 0;
    width: 100%;
    height: 200px;
    color: #fff;
    text-align: center;
    background-color: transparent;
    position: relative;

  }

  .bluebg{
    background-color: #0066CC;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 15px;
    opacity: 0;
  }

  .bluebg:hover{
    opacity: .35;
    transition: 300ms;
  }

  .btn:hover{
        background-color: transparent;
  }

  .btn:hover .col-icon{
        background-color: var(--dark-blue);
  }

  .btn:hover .col-label{
        background-color: #f0f0f0;
  }

  .col-icon{
    background-color: #0176CD;
    width: 50%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 300ms;
  }

  .col-label{
    background-color: #f5f5f5;
    width: 50%;
    display: flex;
    align-items: center;
    padding-left: 20px;
    transition: 300ms;
  }


  .img-icon{
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
  }

  .img-text{
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 175%;
    text-shadow: 3px 3px 12px black;
  }

  @media(max-width: 1060px){

    .btn{
      height: 150px;
    }
  }

  @media(max-width: 425px){
    .btn{
      height: 100px;
    }
  .img-text{
    font-size: 25px;
  }
  }
</style>